<template>
  <q-page>
    <!-- HERO -->
    <section id="inicio">
      <div class="row text-center adicon-hero items-center">
        <div class="col adicon-font-2 text-bold">
          <h1 class="text-h3 text-bold text-white q-mb-lg desktop-only">
            Desarrollando equipos <br />de alto rendimiento
          </h1>
          <div class="text-h4 text-bold text-white q-mb-lg mobile-only">
            Desarrollando equipos de alto rendimiento
          </div>
          <q-btn
            outline
            color="white"
            class="text-bold q-px-md q-py-xs"
            label="conócenos"
            href="#nuestra-mision"
            v-smooth-scroll
          />
        </div>
      </div>
    </section>
    <!-- END HERO -->

    <!-- SERVICES -->
    <section id="servicios">
      <div class="row q-py-xl">
        <div class="col desktop-only"></div>
        <div class="col-lg-10 col-md-12 q-pa-md">
          <div class="row">
            <div class="col">
              <div class="text-h4 adicon-font-2 text-bold text-center q-mb-sm">
                Nuestros Servicios
              </div>
            </div>
          </div>
        </div>
        <div class="col desktop-only"></div>
      </div>
      <div class="row">
        <div class="col"></div>
        <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 q-mb-xl">
          <Carousel
            v-bind="servicesCarouselConfig"
            style="padding: 0 40px 40px 40px"
          >
            <Slide v-for="(service, index) in services" :key="index">
              <div class="service-tile text-center" style="width: 93%">
                <i
                  :class="`fas fa-${service.icon} fa-3x text-deep-orange-7 q-mb-lg`"
                ></i>
                <div
                  class="text-h6 adicon-font-1 text-bold q-mb-sm"
                  v-html="service.title"
                ></div>
                <q-separator
                  color="deep-orange-7"
                  style="width: 100px; margin: 0 auto; height: 2px"
                />
                <div class="text-body adicon-font-1 text-grey-7 q-mt-md">
                  {{ service.description }}
                </div>
              </div>
            </Slide>

            <template #addons>
              <Navigation />
              <Pagination />
            </template>
          </Carousel>
        </div>
        <div class="col"></div>
      </div>
    </section>
    <!-- END SERVICES -->

    <!-- MISSION -->
    <div class="row" id="nuestra-mision">
      <div class="col-lg-6 col-md-6 q-py-xl bg-grey-3">
        <div class="row">
          <div class="col desktop-only"></div>
          <div class="col-lg-7 q-pa-lg">
            <div class="text-h4 adicon-font-2 text-bold q-mb-lg">
              Sobre AMR Advisors
            </div>
            <div class="bg-white q-pa-md q-mb-lg shadow-10" style="width: 70%">
              <q-img :src="require('@/assets/mission.webp')" />
            </div>
            <div class="text-h6 adicon-font-2 text-bold q-mb-md">
              Transformamos organizaciones desde adentro, con estrategia,
              estructura y humanidad.
            </div>
            <div class="text-body adicon-font-1 text-grey-8">
              AMR Advisors es una firma consultora fundada en 2013 por
              <strong>Ana María Reyes</strong>, Psicóloga Organizacional con más
              de 15 años de experiencia en liderazgo estratégico, desarrollo de
              talento humano y transformación institucional. <br /><br />
              Acompañamos a empresas públicas y privadas en el diseño e
              implementación de
              <strong>estructuras organizacionales sólidas</strong>, políticas
              de recursos humanos, procesos de cambio cultural y estrategias
              para construir
              <strong
                >entornos laborales más saludables, productivos y
                sostenibles</strong
              >. <br /><br />
              Nuestro enfoque integra herramientas técnicas de la psicología
              organizacional con una mirada práctica, cercana y estratégica.
              Trabajamos junto a nuestros clientes, no solo como asesores, sino
              como aliados que se integran temporalmente a su equipo, generando
              resultados reales y estructuras que permanecen más allá de nuestra
              intervención.
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 q-pa-xl benefits">
        <div style="border: solid 1px #fff; height: 100%" class="q-pa-lg">
          <div class="row">
            <div class="col-lg-7">
              <div class="text-h4 adicon-font-2 text-bold q-mb-lg text-white">
                Nuestra forma de trabajar
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="text-h6 adicon-font-1 text-white q-mb-lg">
                <i class="fas fa-check text-white on-left"></i>
                Nos involucramos con propósito: entendemos la realidad de cada
                organización.
              </div>
              <div class="text-h6 adicon-font-1 text-white q-mb-lg">
                <i class="fas fa-check text-white on-left"></i>
                Creamos soluciones a medida: nada enlatado, todo adaptado.
              </div>
              <div class="text-h6 adicon-font-1 text-white q-mb-lg">
                <i class="fas fa-check text-white on-left"></i>
                Dejamos capacidad instalada: formamos equipos, no dependencia.
              </div>
              <div class="text-h6 adicon-font-1 text-white q-mb-lg">
                <i class="fas fa-check text-white on-left"></i>
                Trabajamos con ética y cercanía: las personas siempre están en
                el centro.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END MISSION -->

    <!-- WHO ARE WE -->
    <div class="row" id="quienes-somos">
      <div class="col-lg-6 col-md-6 q-pa-xl who-are-we">
        <div style="border: solid 1px #fff" class="q-pa-lg">
          <div class="row">
            <div class="col"></div>
            <div class="col-lg-7">
              <div class="text-h4 adicon-font-2 text-bold q-mb-xl text-white">
                Nuestra Experiencia
              </div>
              <div
                class="adicon-font-1 text-white q-mb-xl text-justify"
                style="line-height: 35px; font-size: 15px"
              >
                Nuestra experiencia empieza desde mediados del año 2013,
                desarrollando servicios de acuerdo a la necesidad de nuestros
                clientes y del mercado nacional, en diferentes organizaciones y
                áreas, en estrecha relación directa con nuestros principios.
                <br /><br />
                Hemos ayudado a reestructurar las organizaciones desde la base,
                con procesos bien definidos, que van desde la cultura
                organizacional hasta ayudar a certificarlas en estándares de
                calidad. Nuestro alcance abarca la verificación de resultados
                óptimos.
              </div>
              <q-btn
                outline
                label="contáctanos"
                color="white"
                class="q-px-md q-py-xs q-mb-xl text-bold adicon-font-2"
                href="#contacto"
                v-smooth-scroll
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 q-py-xl bg-grey-3">
        <div class="row">
          <div style="width: 40px" class="desktop-only"></div>
          <div class="col-lg-7 q-pa-lg">
            <div class="text-h4 adicon-font-2 text-bold q-mb-xl">
              Servicios Administrativos
            </div>
            <div class="text-body2 adicon-font-1 text-grey-7 q-mb-lg">
              Todo lo dispuesto de nuestra parte como servicios anexos para la
              mejora continua como valor agregado en el desarrollo de la
              organización y de su recurso humano.
            </div>
            <div class="text-h6 adicon-font-2 text-bold q-mb-md">
              <i class="fas fa-globe text-deep-orange-7 on-left"></i
              >Traducciones
            </div>
            <div class="text-body2 adicon-font-1 text-grey-7 q-mb-lg">
              Traducciones de documentos (Italiano - Español, Español -
              Italiano, Inglés - Español, Español - Inglés, Alemán - Español,
              Español - Alemán)
            </div>
            <div class="text-h6 adicon-font-2 text-bold q-mb-md">
              <i class="far fa-handshake text-deep-orange-7 on-left"></i
              >Asistencia y organización
            </div>
            <div class="text-body2 adicon-font-1 text-grey-7">
              Organización y desarrollo de eventos corporativos
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END WHO ARE WE -->

    <!-- CLIENTS -->
    <section class="q-py-xl" id="clientes">
      <div class="row">
        <div class="col desktop-only"></div>
        <div class="col-lg-7 col-xs-12 col-md-12 col-sm-12">
          <div class="text-h4 adicon-font-2 text-bold text-center">
            Nuestros clientes
          </div>
          <h2 class="hidden">Nuestros clientes</h2>
          <Carousel v-bind="carouselConfig" style="padding: 40px 20px">
            <Slide v-for="(image, index) in clients" :key="index">
              <q-img :src="require(`@/assets/clients/${image}`)" />
            </Slide>

            <template #addons>
              <Navigation />
              <Pagination />
            </template>
          </Carousel>
        </div>
        <div class="col desktop-only"></div>
      </div>
    </section>
    <!-- END CLIENTS -->

    <!-- DIRECTORS -->
    <section class="q-py-xl bg-grey-3" id="directors">
      <div class="row">
        <div class="col desktop-only"></div>
        <div class="col-lg-7 col-xs-12 col-md-12 col-sm-12">
          <div class="text-h4 adicon-font-2 text-bold text-center q-mb-lg">
            Nuestra dirección
          </div>

          <h2 class="hidden">Nuestra dirección</h2>
        </div>
        <div class="col desktop-only"></div>
      </div>
      <div class="row q-mb-lg">
        <div class="col" />
        <div class="col-xs-4 col-sm-3 col-md-2 col-lg-1">
          <q-img :src="require('@/assets/ana-maria.jpg')" />
        </div>
        <div class="col" />
      </div>
      <div class="row text-justify">
        <div class="col" />
        <div class="col-xs-11 col-sm-11 col-md-9 col-lg-7">
          <div class="text-subtitle2 text-bold text-center q-mb-xs">
            Mgtr. Ana María Reyes de Quevedo
          </div>
          <div class="text-subtitle2 text-bold text-center q-mb-lg">
            Fundadora y Gerente General - AMR Advisors<br />
            Psicóloga Organizacional<br />
            Consultora en Gestión Humana y Desarrollo Organizacional
          </div>
          <div class="text-body">
            Ana María Reyes es Psicóloga Organizacional con más de 15 años de
            experiencia en el diseño e implementación de estrategias de
            desarrollo humano, liderazgo y transformación organizacional.
            Fundadora y Gerente General de <strong>AMR Advisors</strong> desde
            2013, ha acompañado a empresas públicas y privadas en la creación de
            estructuras funcionales, procesos de gestión por competencias,
            estudios de clima, certificaciones ISO y fortalecimiento
            institucional. <br /><br />
            Ha ocupado posiciones de alta dirección en organizaciones clave,
            como la <strong>Autoridad Marítima de Panamá</strong>, donde lideró
            el área de Recursos Humanos, y <strong>Minera Panamá</strong>, como
            Superintendente de Capacitación y Desarrollo. Representó al país
            como <strong>Embajadora de Panamá en Italia</strong> entre 2019 y
            2024, liderando la gestión diplomática, administrativa y cultural en
            la Embajada en Roma.
            <br />
            Es <strong>Licenciada en Psicología Cum Laude por la USMA</strong> y
            becaria de la Unión Europea para la Maestría en Psicología del
            Trabajo, las Organizaciones y del Personal (WOP-P), con
            <strong>doble titulación</strong> de la
            <strong>Università di Bologna (Italia)</strong> y la
            <strong>Universidad de Valencia (España).</strong>
            <br /><br />
            Cuenta con certificaciones en:
            <ul>
              <li>Desarrollo del Talento (Global Novations)</li>
              <li>
                Facilitación DDI (Development Dimensions International, EE.UU.)
              </li>
              <li>Project Management y Gestión del Capital Humano (ADEN)</li>
              <li>Auditoría Interna ISO 9001 (Delta Q)</li>
            </ul>
            <br />
            Ha sido docente universitaria en psicología organizacional y
            aplicada, y domina el español, inglés e italiano, con formación en
            francés.
            <br /><br />
            Su trabajo se basa en la convicción de que las organizaciones sanas
            y eficientes se construyen desde el respeto por las personas, la
            claridad en los procesos y una visión estratégica del cambio.
          </div>
        </div>
        <div class="col" />
      </div>
    </section>
    <!-- END DIRECTORS -->

    <!-- CONTACT -->
    <section class="q-py-xl" id="contacto">
      <div class="row">
        <div class="col desktop-only"></div>
        <div class="col-lg-7">
          <div class="row">
            <div class="col-12 q-pa-md q-mb-md">
              <div class="text-h4 adicon-font-2 text-bold text-center">
                Contáctanos
              </div>
              <h2 class="hidden">Contactanos</h2>
            </div>
            <div class="col-lg-6 col-xs-12 q-pa-md">
              <q-input
                square
                filled
                label="Nombre"
                class="adicon-font-1"
                v-model="formData.name"
                color="deep-orange-7"
              />
            </div>
            <div class="col-lg-6 col-xs-12 q-pa-md">
              <q-input
                square
                filled
                label="Teléfono"
                class="adicon-font-1"
                mask="########"
                v-model="formData.telephone"
                color="deep-orange-7"
              />
            </div>
            <div class="col-lg-12 col-xs-12 q-pa-md">
              <q-input
                square
                filled
                label="Correo electrónico"
                class="adicon-font-1"
                type="email"
                v-model="formData.email"
                color="deep-orange-7"
              />
            </div>
            <div class="col-lg-12 col-xs-12 q-pa-md q-mb-md">
              <q-input
                square
                filled
                label="Mensaje"
                type="textarea"
                rows="7"
                class="adicon-font-1"
                v-model="formData.content"
                color="deep-orange-7"
              />
            </div>
            <q-btn
              color="deep-orange-7"
              label="Enviar"
              class="adicon-font-2 text-bold q-py-xs q-px-lg"
              style="margin: 0 auto"
              @click="validateContactData()"
            />
          </div>
        </div>
        <div class="col desktop-only"></div>
      </div>
      <div class="row"></div>
    </section>

    <q-dialog v-model="contactFormDialog">
      <q-card>
        <q-card-section>
          <div class="text-h6 text-center">
            <i
              class="fas fa-check fa-2x text-green-7"
              v-if="contactSuccess"
            ></i>
            <i class="fas fa-times fa-2x text-red-7" v-else></i>
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div
            class="text-h6 text-bold adicon-font-2 text-center"
            v-if="!contactSuccess"
          >
            Porfavor verifica todos los campos.
          </div>
          <div class="text-h6 text-bold adicon-font-2 text-center" v-else>
            Su mensaje ha sido enviado con exito. <br />Pronto nos pondremos en
            contacto con usted.
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Aceptar" color="deep-orange-7" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!-- END CONTACT -->

    <!-- FOOTER -->
    <section>
      <div class="row bg-cyan-8 q-py-xl">
        <div class="col desktop-only"></div>
        <div class="col-lg-7 q-pa-md">
          <div class="row q-mb-lg">
            <div class="col-lg-4 col-md-4 col-xs-12">
              <div
                class="q-mb-md"
                style="
                  width: 50px;
                  height: 50px;
                  background-color: white;
                  border-radius: 25px;
                  padding: 10px;
                "
              >
                <q-img :src="require('@/assets/logo.svg')" />
              </div>

              <div
                class="text-body2 text-white adicon-font-2 text-bold q-mb-sm"
              >
                AMR Advisors
              </div>
              <div class="text-body2 text-white adicon-font-1 q-mb-md">
                Apoyamos a Recursos Humanos en todas las etapas de desarrollo,
                desde la definición de procesos hasta el reclutamiento y
                formación de equipos efectivos.
              </div>
            </div>
            <div class="col"></div>
            <div class="col-lg-2 col-md-2 col-xs-6">
              <div
                class="text-body2 text-white adicon-font-2 text-bold q-mb-sm"
              >
                Enlaces
              </div>
              <a
                href="#inicio"
                v-smooth-scroll
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                >Inicio</a
              >
              <a
                href="#servicios"
                v-smooth-scroll
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                >Servicios</a
              >
              <a
                href="#nuestra-mision"
                v-smooth-scroll
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                >Nosotros</a
              >
              <a
                href="#clientes"
                v-smooth-scroll
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                >Nuestros clientes</a
              >
              <a
                href="#directors"
                v-smooth-scroll
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                >Nuestra dirección</a
              >
              <a
                href="#contacto"
                v-smooth-scroll
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                >Contacto</a
              >
            </div>
            <div class="col-lg-2 col-md-2 col-xs-6">
              <div
                class="text-body2 text-white adicon-font-2 text-bold q-mb-sm"
              >
                Siguenos
              </div>
              <a
                href="https://www.facebook.com/AMRAdvisors/"
                target="_blank"
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                ><i class="fab fa-facebook"></i>&nbsp;AMRAdvisors</a
              >
              <a
                href="https://www.linkedin.com/company/amr-advisors/"
                target="_blank"
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                ><i class="fab fa-linkedin"></i>&nbsp;AMR Advisors</a
              >
              <a
                href="https://twitter.com/AMRAdvisors"
                target="_blank"
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                ><i class="fab fa-twitter"></i>&nbsp;AMRAdvisors</a
              >
              <a
                href="https://www.instagram.com/amradvisors"
                target="_blank"
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                ><i class="fab fa-instagram"></i>&nbsp;amradvisors</a
              >
            </div>
            <div class="col-lg-3">
              <div
                class="text-body2 text-white adicon-font-2 text-bold q-mb-sm"
              >
                Contactanos
              </div>
              <!-- <a
                href="tel:264-5598"
                target="_blank"
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                ><i class="fas fa-phone-alt"></i>&nbsp;264-5598</a
              > -->
              <a
                href="mailto:vacantes@amradvisors.com.pa"
                target="_blank"
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                ><i class="far fa-envelope"></i
                >&nbsp;vacantes@amradvisors.com.pa</a
              >
              <!-- <a
                href="https://maps.app.goo.gl/baTS1w2AHC9FbBCL9"
                target="_blank"
                class="adicon-font-1 text-white q-mb-sm"
                style="text-decoration: none; display: block"
                ><i class="fas fa-map-marker-alt"></i>&nbsp;Panamá, Panama, Pan.
                Panama Tower #507</a
              > -->
            </div>
          </div>
          <div class="row">
            <q-separator color="secondary" class="q-mb-lg" />
            <div
              class="text-body2 adicon-font-1 text-white text-center full-width"
            >
              Copyright &copy; {{ new Date().getFullYear() }} Todos los derechos
              reservados. Desarrollado por
              <a
                href="https://blueballoon.io"
                target="_blank"
                class="text-white"
                >BlueBalloon Inc.</a
              >
            </div>
          </div>
        </div>
        <div class="col desktop-only"></div>
      </div>
    </section>
    <!-- END FOOTER -->
  </q-page>
</template>

<script lang="ts" setup>
import "vue3-carousel/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import { ref } from "vue";

// REFS
const formData = ref({
  name: "",
  telephone: "",
  email: "",
  content: "",
});
const contactFormDialog = ref(false);
const contactSuccess = ref(false);

// METHODS
const validateContactData = () => {
  if (
    formData.value.name.length > 0 ||
    formData.value.telephone.length >= 7 ||
    formData.value.email.match(validEmail) ||
    formData.value.content.length > 0
  ) {
    sendContactEmail();
    contactSuccess.value = true;
    formData.value = {
      name: "",
      telephone: "",
      email: "",
      content: "",
    };
  } else {
    contactSuccess.value = false;
  }
  contactFormDialog.value = true;
};

const sendContactEmail = () => {
  console.log("SENDING EMAIL");
};

// VALID EMAIL REGEX
const validEmail =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// CAROUSEL CONFIG
const carouselConfig = {
  wrapAround: true,
  autoplay: 2000,
  breakpoints: {
    300: {
      itemsToShow: 2,
      snapAlign: "center",
    },
    400: {
      itemsToShow: 3,
      snapAlign: "center",
    },
    500: {
      itemsToShow: 5,
      snapAlign: "center",
    },
  },
};

// CAROUSEL CONFIG
const servicesCarouselConfig = {
  wrapAround: true,
  autoplay: 5000,
  breakpoints: {
    300: {
      itemsToShow: 1,
    },
    800: {
      itemsToShow: 2,
    },
    900: {
      itemsToShow: 3,
    },
    1300: {
      itemsToShow: 4,
    },
  },
};

// CAROUSEL IMGS
const clients = [
  "arenera_balboa.png",
  "bypass_cafe.png",
  "cerro_punta.png",
  "copanac_new.png",
  "flex.png",
  "furniture_city.png",
  "grupo_sigma.png",
  "hospital_nacional.png",
  "itesa.png",
  "kenneth_cole.png",
  "nisato.png",
  "plastifom.png",
  "riba_smith.png",
  "tecnilab.png",
];

const services = [
  {
    title: "Diseño y fortalecimiento de RRHH",
    icon: "user-check",
    description:
      "Creamos o reestructuramos departamentos de Recursos Humanos para que operen con autonomía y estrategia.",
  },
  {
    title: "Reingeniería y desarrollo organizacional",
    icon: "sync-alt",
    description:
      "Optimización de procesos, estructura y cultura para lograr eficiencia.",
  },
  {
    title: "Desarrollo de estructuras organizativas, puestos y KPI's.",
    icon: "chart-line",
    description:
      "Diseño de organigramas, descripciones de puesto y métricas de gestión.",
  },
  {
    title: "Headhunting<br />&nbsp;",
    icon: "search",
    description:
      "Búsqueda y selección estratégica de talento clave para tu organización.",
  },
  {
    title: "Estudios de clima<br />organizacional",
    icon: "feather-alt",
    description:
      "Analizamos el ambiente interno para impulsar acciones concretas de mejora y bienestar laboral.",
  },
  {
    title: "Desarrollo de sistemas de evaluación de personal",
    icon: "people-arrows",
    description:
      "Aplicamos herramientas de retroalimentación integral para potenciar el rendimiento y desarrollo del talento.",
  },
  {
    title: "Talleres de<br/>integración",
    icon: "hammer",
    description:
      "Diseñamos talleres prácticos que fortalecen habilidades blandas y cohesionan equipos de alto desempeño.",
  },
  {
    title: "Gestión del cambio y liderazgo",
    icon: "star",
    description:
      "Acompañamos procesos de transformación organizacional con enfoque humano y estratégico.",
  },
  {
    title: "Sistema de gestión de calidad",
    icon: "tasks",
    description:
      "Documentamos y optimizamos procesos clave para preparar a tu organización hacia la certificación y mejora continua.",
  },
  {
    title: "Coaching psicológico profesional",
    icon: "brain",
    description:
      "Sesiones individuales de acompañamiento para quienes buscan claridad, desarrollo personal y bienestar laboral.",
  },
];
</script>

<style>
.adicon-hero {
  background-image: url("../assets/hero2.png");
  background-position: center;
  height: 600px;
}

.service-tile {
  border: solid 1px #e3e3e3;
  padding: 60px 20px;
  min-height: 370px !important;
}
.who-are-we {
  background-image: url("../assets/who_are_we.png");
  background-position: center center;
  background-size: cover;
}
.benefits {
  background-image: url("../assets/benefits.png");
  background-position: center center;
  background-size: cover;
}
</style>
